import axios from "axios";
import { refreshToken, isTokenExpiring } from "../authConfig";
import {
  getFromBrowserStorage,
  getJsonFromBrowserStorage,
  clearAuthStorage,
} from "./browserStorage";

const api = axios.create({
  //baseURL: 'https://4.255.0.76/api',
  //baseURL: 'https://localhost:44368/api',
  //baseURL: "https://20.241.136.167/api",
  // baseURL: 'https://20.241.136.167/api',
  baseURL: 'https://feedassayportal.com/api',
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  async (config) => {
    // Check login type and handle token refresh accordingly
    const loginType = getFromBrowserStorage("loginType");
    
    if (loginType === "msal") {
      // MSAL token - use existing logic
      if (isTokenExpiring()) {
        await refreshToken();
      }
    }
    // For custom login, just use the token as-is without refresh logic
    
    const token = getFromBrowserStorage("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      const role = getJsonFromBrowserStorage("currentRole");
      const isLabAdmin = role === "Lab Admin" || role === "Analyst" || role === "IT Admin";
      if (isLabAdmin) {
        const selectedLocationId = getFromBrowserStorage("selectedLocationId");
        if (selectedLocationId) {
          config.headers.PhibroLocation = selectedLocationId;
        }
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      console.log("401 Unauthorized, clearing auth data and redirecting...");
      
      // Check login type and redirect accordingly
      const loginType = getFromBrowserStorage("loginType");
      
      // Clear all auth data
      clearAuthStorage();

      localStorage.clear();
      sessionStorage.clear();
    }
    return Promise.reject(error);
  }
);

export default api;